import { useEffect } from "react";

export const useScannerHelper = (
  onScan = () => {},
  dependency = [],
  stopDefault = false
) => {
  useEffect(() => {
    let barcode = "";

    const handleKeyDown = (event) => {
      const active = document.activeElement;
      const isTyping = 
        active?.tagName === "INPUT" ||
        active?.tagName === "TEXTAREA" ||
        active?.isContentEditable;

      // If user is typing in a field, skip barcode capture
      if (isTyping) return;

      if (stopDefault) {
        event.preventDefault();
        event.stopPropagation();
      }

      if (["Enter", "Tab"].includes(event.key)) {
        if (barcode) {
          onScan(barcode.trim());
          barcode = "";
        }
      } else if (/^[a-zA-Z0-9\-\s]$/.test(event.key)) {
        barcode += event.key;
      }
    };

    window.addEventListener("keydown", handleKeyDown);

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [onScan, ...dependency]);
};
